<h2 class="typo-h2 text-text-primary">
  {{ service.inviterNameSignal() }} {{ 'ffd_notes_invitation_login_title' | translate }}
  {{ service.siteNameSignal() ?? '' }}
</h2>

<lib-login-form
  class="mt-8 block"
  [alternativeDesign]="true"
  [isFfdNotes]="true"
  [isLoading]="service.isLoginLoadingSignal()"
  (login)="onLogin($event)"
></lib-login-form>
